import gql from 'graphql-tag'

const AllClaimStates = gql`
  query allClaimStates {
    allClaimStates
  }
`

export { AllClaimStates }



// WEBPACK FOOTER //
// ./src/queries/AllClaimStates.js